import React from "react";
import LanderRouter from "./landers/LanderRouter";
import { LanderConfigProvider } from "./commons/ConfigContext";
import {
  createLanderConfig,
  getApiUrl,
  getLanderSystem,
  parseLanderQueryParam,
} from "./commons/LanderConfig";
import { useFetch } from "./commons/useFetch";
import { getVisitorIdentifier } from "./commons/HelperFunctions";
import { System } from "./commons/Constants";
import { I18nProvider } from "./i18n/I18nProvider";

const errorPageStyle = `body {
  margin: auto;
  padding: 10px;
  background-color: #F3F7FC;
  font-family: 'Arial';
}`;

export const ParkingLander = () => {
  const queryConfig = parseLanderQueryParam(window.location.search);
  // Send the visitor id as a request header (never in the URL) so Hivemind
  // buckets on the same identity events are tagged with. Scoped to ParkWeb to
  // match getApiUrl's system branch; the id is memoized in getVisitorIdentifier
  // so it's stable per page load.
  const extraHeaders =
    getLanderSystem(queryConfig) === System.PARKWEB
      ? { "X-Visitor-Id": getVisitorIdentifier() }
      : {};
  const { body, err } = useFetch(
    getApiUrl(queryConfig),
    queryConfig,
    extraHeaders
  );

  // Fetch error - event already fired by useFetch
  if (err) {
    return (
      <>
        <style>{errorPageStyle}</style>
        <div id="errorMessage" />
      </>
    );
  }

  // Loading
  if (!body) {
    return null;
  }

  // Always create full config - routing logic decides what to use
  const landerConfig = createLanderConfig(body, queryConfig);

  return (
    <I18nProvider isI18n={ landerConfig.lander?.i18n }>
      <LanderConfigProvider
        landerConfig={ landerConfig }
        queryConfig={ queryConfig }
        targeted={ body.targeted }
      >
        <LanderRouter />
      </LanderConfigProvider>
    </I18nProvider>
  );
};
